import './_styles.scss';
import React from 'react';
import { MdError } from 'react-icons/md'

export default (props) => {

  const {
    name,
    error,
    value,
    placeholder,
  } = props;

  const defaultProps = () => {

    const omit = ['type', 'onChange', 'placeholder']

    return Object.keys(props).reduce((object, key) => {

      if (!omit.includes(key)) object[key] = props[key];

      return object;

    }, {});

  };

  //console.log(`object ${name}:`, error);

  const className = () => {

    const HasValue = !!value ? 'loaded' : '';

    const HasError = !!error ? 'invalid' : '';

    return `${HasValue} ${HasError}`;

  }

  const onChangeEvent = (e) => {

    const { data } = e.nativeEvent;

    const { pattern, onChange } = props;

    const noSpace = (pattern === 'no-space');

    return ((data===' ') && !!noSpace) ? false : onChange(e);

  }

  return (
    <div id={name} className={!!error ? 'Input Invalid' : 'Input'}>

      <input
        {...defaultProps()}
        className={className()}
        onChange={onChangeEvent}
        type={props.type || 'text'}
      />

      <label htmlFor={name} className={`label`}>
        { (!error) ? placeholder : error }
      </label>

      { (!!error) && <MdError className='error-icon'/> }

    </div>
  )
}
